const mapBoundsFilter = (data, bounds) => {
  if (!bounds) return data;
  return data.filter((item) => {
    return (
      item.lat >= bounds.minLat 
        && item.lat <= bounds.maxLat 
        && item.lng >= bounds.minLng 
        && item.lng <= bounds.maxLng
    );
  });
}

export { mapBoundsFilter }
